// This exists in its own file to prevent circular dependencies.
// NOTE: These strings double as `data-testid` values for the expanded sections to ease testing.
export enum ConversationSummarySectionsEnum {
  PINNED_ACTIVITIES = 'PINNED_ACTIVITIES',
  ATTACHMENTS = 'ATTACHMENTS',
  DETAILS = 'ADVANCED',
  CUSTOM_ATTRIBUTES = 'CUSTOM_ATTRIBUTES',
  REFERENCE_PREVIEWERS = 'REFERENCE_PREVIEWERS',
}
